module.exports = {"waybillNumberTableLabel":"Numer listu przewozowego:","waybillCourierTableLabel":"Przewoźnik:","editWaybillDataTableLabel":"Edytuj dane listu przewozowego:","waybillNumberEditButtonText":"Edytuj","waybillNumberActualNumberInputLabel":"Obecny numer:","waybillNumberNewNumberInputLabel":"Nowa wartość: *","waybillNumberNewNumberInputPlaceholder":"Nowa wartość..."}


//////////////////
// WEBPACK FOOTER
// ./src/components/WaybillData/translate.json
// module id = 462
// module chunks = 0